import { render, staticRenderFns } from "./flowCase.vue?vue&type=template&id=4df55336&scoped=true"
import script from "./flowCase.vue?vue&type=script&lang=js"
export * from "./flowCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df55336",
  null
  
)

export default component.exports